import React, { useState } from 'react';
import Card from '../components/Card';
import { Gift, ArrowRight, Wallet } from 'lucide-react';

export default function TransferRewards() {
    const [amount, setAmount] = useState('');
    const rewardsBalance = 2458;
    const conversionRate = 0.01; // 1 point = $0.01
    const convertedAmount = Number(amount) * conversionRate;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Handle transfer
    };

    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Transfer Rewards to Wallet</h1>

            <div className="grid md:grid-cols-2 gap-6">
                <Card className="bg-gradient-to-br from-[#001f3f] to-navy-700 text-white">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-200">Available Points</p>
                            <h3 className="text-3xl font-bold mt-1">{rewardsBalance}</h3>
                        </div>
                        <Gift size={32} className="opacity-80" />
                    </div>
                </Card>

                <Card>
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600">Conversion Rate</p>
                            <h3 className="text-xl font-semibold mt-1">1 Point = $0.01</h3>
                        </div>
                        <ArrowRight size={24} className="text-gray-400" />
                    </div>
                </Card>
            </div>

            <Card>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Points to Convert
                        </label>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            min="100"
                            max={rewardsBalance}
                            placeholder="Enter amount of points"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-navy-700 focus:border-navy-700"
                        />
                        <p className="mt-1 text-sm text-gray-500">
                            Minimum 100 points required for conversion
                        </p>
                    </div>

                    {amount && (
                        <div className="relative">
                            <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-200" />
                            </div>
                            <div className="relative flex justify-center">
                                <div className="bg-white px-4">
                                    <ArrowRight size={24} className="text-gray-400" />
                                </div>
                            </div>
                        </div>
                    )}

                    {amount && (
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-sm text-gray-600">You will receive</p>
                                    <p className="text-2xl font-bold text-navy-700 mt-1">
                                        ${convertedAmount.toFixed(2)}
                                    </p>
                                </div>
                                <Wallet size={24} className="text-navy-700" />
                            </div>
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={!amount || Number(amount) > rewardsBalance || Number(amount) < 100}
                        className="w-full px-4 py-2 bg-navy-700 text-white rounded-lg hover:bg-navy-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Convert Points to Cash
                    </button>

                    <p className="text-center text-sm text-gray-500">
                        Points will be converted and transferred to your wallet immediately
                    </p>
                </form>
            </Card>
        </div>
    );
}